import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8 7.607A1.4 1.4 0 0 1 6.81 6.94c-.28-.456-.658-.92-1.08-1.254-.422-.335-.807-.48-1.147-.48-.657 0-1.11.23-1.418.586-.325.377-.597 1.025-.597 2.023 0 .476.177 1.073.574 1.782.392.698.95 1.42 1.592 2.12 1.14 1.246 2.446 2.32 3.272 2.953.824-.627 2.126-1.69 3.263-2.93.639-.698 1.196-1.419 1.586-2.12.396-.708.575-1.314.575-1.805 0-1.173-.288-1.786-.572-2.097-.267-.293-.703-.509-1.446-.513-.324-.001-.704.14-1.13.479-.426.338-.808.806-1.092 1.262a1.4 1.4 0 0 1-1.192.66ZM7.097 5.04c.36.37.666.779.905 1.167a6.93 6.93 0 0 1 .908-1.165c.675-.69 1.538-1.24 2.509-1.236 2.048.01 3.411 1.24 3.411 4.01 0 3.263-4.652 6.992-6.276 8.195a.915.915 0 0 1-1.102-.003C5.83 14.795 1.17 11.033 1.17 7.816c0-2.488 1.363-4.01 3.415-4.01.98 0 1.843.547 2.514 1.234Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
